exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "aside.active .langs {\n  display: none;\n}\naside .langs {\n  text-align: center;\n  margin: 10px;\n}\naside .langs a {\n  font-size: 11px;\n  cursor: pointer;\n  background: rgb(32, 35, 70);\n  margin: 0;\n  padding: 0 20px;\n  box-shadow: 0 0 2px;\n}\naside .langs a.selected {\n  font-weight: bold;\n  cursor: default;\n  background: white;\n  color: #202346;\n}", ""]);

// exports
